import { reactive } from '@vue/composition-api'
import { apiEndpoint } from '@/configs/api/api-configs'

export function privilegeInfoModel() {
  const createForm = reactive({
    api: `${apiEndpoint.bcrm_platform}/Privilege/Create`,
    method: 'POST',
    payload: {
      Status: 1, // required
      Type: 4, // required
      // 1 = Reward/Privilege (RP)
      // 2 = Unlimited Coupon (UCP)
      // 3 = Coupon (CP)
      // 4 = Coupon Code (CPC)
      CPC_Type: 5, // 0 = None , 5 = External Code //required
      Name_Th: 'Reward Name', // required
      Name_En: 'Reward Name', // required
      SubName_Th: 'Reward SubName',
      SubName_En: 'Reward SubName_En',
      Desc_Th: 'Reward Desc_Th',
      Desc_En: 'Reward Desc_En',
      TermsAndCondsTh: 'TermsAndCondsTh',
      TermsAndCondsEn: 'TermsAndCondsEn',
      Remark: 'Remark',
      Point_Ref: 0, // maybe 0 here ไม่ใช้ในการคำนวณ
      Value_Ref: 100, // Default = 0
      Reserve_Timeout: 300, // default = 300
      Code_Qty_Per_Redeem: 1, // default = 1
      Issue_Overall: 0, // 0 = unlimited
      Issue_PerDay: 0,
      Issue_PerCustomer: 0,
      Issue_PerCustomer_PerDay: 0,
      Redeem_Overall: 0,
      Redeem_PerDay: 0,
      Redeem_PerCustomer: 0,
      Redeem_PerCustomer_PerDay: 0,
      Valid_From: '2021-11-15 16:05:24.4457382', // required
      Valid_Through: '2022-11-15 16:05:24.4457382', // required
      Exp_Mode: 1, // required
      //  for Privilege Type 2 / 3 / 4 only (อันนี้พี่ลุย note ไว้ แต่เห็นของ BOS Type 1 มี Exp Mode)
      // 1 = None
      // 2 = Period
      // 3 = Fixed Date
      Exp_Rounding_Mode: 1, // 1 = None/As-is | 2 = Full Day 00:00
      Exp_Period_Year: 0,
      Exp_Period_Month: 0,
      Exp_Period_Day: 0,
      Exp_Period_Hour: 0,
      Exp_Period_Minute: 0,
      Exp_Period_FixedDate: '2022-11-15 16:05:24.4457382',
      // IsVoidable: false,
      Store_Mappings: [
      ],
      Inventory_Mappings: [
      ],
      Req_IdentityId: 1, // required
    },
  })

  const editForm = reactive({
    api: `${apiEndpoint.bcrm_platform}/Privilege/Edit`,
    method: 'POST',
    payload: {
      Privilege_Id: 17, // required
      Status: 1, // required
      Name_Th: 'Reward Edit Name', // required
      Name_En: 'Reward Edit Name', // required
      SubName_Th: 'Reward Edit SubName',
      SubName_En: 'Reward Edit SubName_En',
      Desc_Th: 'Reward Edit Desc_Th',
      Desc_En: 'Reward Edit Desc_En',
      TermsAndCondsTh: 'TermsAndCondsTh',
      TermsAndCondsEn: 'TermsAndCondsEn',
      Remark: 'Remark',
      Point_Ref: 0, // maybe 0 here ไม่ใช้ในการคำนวณ
      Value_Ref: 100,
      Reserve_Timeout: 300, // default = 300
      Code_Qty_Per_Redeem: 1, // default = 1
      Issue_Overall: 100, // 0 = unlimited
      Issue_PerDay: 0,
      Issue_PerCustomer: 0,
      Issue_PerCustomer_PerDay: 0,
      Redeem_Overall: 0,
      Redeem_PerDay: 0,
      Redeem_PerCustomer: 0,
      Redeem_PerCustomer_PerDay: 0,
      Valid_From: '2021-11-15 16:05:24.4457382', // required
      Valid_Through: '2022-11-15 16:05:24.4457382', // required
      Exp_Mode: 2, // required
      //  for Privilege Type 2 / 3 / 4 only (อันนี้พี่ลุย note ไว้ แต่เห็นของ BOS Type 1 มี Exp Mode)
      // 1 = None
      // 2 = Period
      // 3 = Fixed Date
      Exp_Rounding_Mode: 1, // 1 = None/As-is | 2 = Full Day 00:00
      Exp_Period_Year: 0,
      Exp_Period_Month: 3,
      Exp_Period_Day: 0,
      Exp_Period_Hour: 0,
      Exp_Period_Minute: 0,
      Exp_Period_FixedDate: '2022-11-15 16:05:24.4457382',
      // IsVoidable: false,
      Store_Mappings: [],
      Inventory_Mappings: [],
      Req_IdentityId: 1,
    },
  })

  const fetchDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/Privilege/Detail`,
    method: 'POST',
    payload: {
      Privilege_Id: 17,
    },
  })

  const fetchStoreList = reactive({
    api: `${apiEndpoint.bcrm_platform}/Privilege/Store_List`,
    method: 'POST',
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [{ Seq: 1, Key: 'query', Value: '' }],
      Ordering: [],
    },
  })

  const fetchExchangeCarriers = reactive({
    api: apiEndpoint.bcrm_platform +'/Privilege/Exchange_Carriers',
    method: 'GET',
    payload: {}
  })

  return {
    createForm,
    editForm,
    fetchDetail,
    fetchStoreList,
    fetchExchangeCarriers,
  }
}

export function privilegeImageModel() {
  const createForm = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeImage/Create`,
    method: 'POST',
    payload: {
      Privilege_Id: 1, // required
      Req_IdentityId: 1, // required
      Group_Image: [
        {
          Type: 1, // required
          Name: '', // required
          Key: '',
          Remark: '',
          Desc_Th: '',
          Desc_En: '',
          ImageList: [
            {
              Image: '',
              Seq: 1,
            },
          ],
        },
      ],
    },
  })

  const editForm = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeImage/Edit`,
    method: 'POST',
    payload: {
      Privilege_Id: 1, // required
      Req_IdentityId: 1, // required
      Group_Image: [
        {
          Group_Image_Id: 4, // required
          Type: 1, // required
          Name: '',
          Key: '',
          Remark: '',
          Desc_Th: '',
          Desc_En: '',
          ImageList: [
            {
              Image: '',
              Seq: 1,
            },
          ],
          ImageList_Delete: [5],
        },
      ],
    },
  })

  const fetchDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeImage/Detail`,
    method: 'POST',
    payload: {
      Privilege_Id: 13,
      Page: 1,
      Limit: 10,
    },
  })

  const fetchGroupImageList = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeImage/Group_Image_Detail`,
    method: 'POST',
    payload: {
      Privilege_Id: 13,
      Group_Image_Id: 1,
    },
  })

  const updateMasterImage = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeImage/Update_Master_Image`,
    method: 'POST',
    payload: {
      Privilege_Id: 13,
      Req_IdentityId: 1,
      Main_Image: '',
    },
  })

  const reorderGroupImageList = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeImage/Reorder`,
    method: 'POST',
    payload: {
      Privilege_Id: 13, // required
      Group_Image_Id: 3, // required
      From: 3, // required
      To: 1, // required
    },
  })

  const deleteItemList = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeImage/Delete`,
    method: 'POST',
    payload: {
      Privilege_Id: 1, // required
      Group_Image_Id: 3, // required
      Req_IdentityId: 1, // required
    },
  })

  return {
    createForm,
    editForm,
    fetchDetail,
    fetchGroupImageList,
    updateMasterImage,
    reorderGroupImageList,
    deleteItemList,
  }
}

export function privilegeTagModel() {
  const fetchTagDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeTag/Detail`,
    method: 'POST',
    payload: {
      Privilege_Id: 1,
    },
  })

  const addTag = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeTag/Add_Tag`,
    method: 'POST',
    payload: {
      Privilege_Id: 1,
      Tag: 'vip-test', //* ** พิมได้ตาม pattern นี้ เท่านั้น // ตัวพิมเล็กและเว้นวรรคด้วย -
    },
  })

  const removeTag = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeTag/Remove_Tag`,
    method: 'POST',
    payload: {
      Privilege_Id: 1,
      Tag: 'vip',
    },
  })
  return {
    fetchTagDetail,
    addTag,
    removeTag,
  }
}

export function privilegeCriteriaModel() {
  const createForm = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeCriteria/Create`,
    method: 'POST',
    payload: {
      Privilege_Id: 1,
      Type: 2, // required
      Priority: 27, // required
      Name: 'Test', // required
      Point_Mode: 2, // required 1 : Default use Privilege.Point_Ref | 2 : Custome_Point
      Point: 10, // required
      Note: 'Test',
      IsVisible: true, // required
      IsIssuable: true, // required
      IsRedeemable: true, // required
      Req_IdentityId: 1, // required
      TagList: [
        {
          Seq: 1,
          Tag: 'free112',
          Condition: 'AND',
          GroupLv: 1,
          GroupNum: 1,
        },
        {
          Seq: 2,
          Tag: 'tag011',
          Condition: 'OR',
          GroupLv: 1,
          GroupNum: 1,
        },
        {
          Seq: 3,
          Tag: 'tag021',
          Condition: 'OR',
          GroupLv: 1,
          GroupNum: 1,
        },
        {
          Seq: 4,
          Tag: 'festival1',
          Condition: 'OR',
          GroupLv: 1,
          GroupNum: 1,
        },
      ],

      TierList: [
        {
          Seq: 1,
          Tag: 'member',
          Condition: 'AND',
          GroupLv: 1,
          GroupNum: 1,
        },
        {
          Seq: 2,
          Tag: 'super',
          Condition: 'OR',
          GroupLv: 1,
          GroupNum: 1,
        },
        {
          Seq: 3,
          Tag: 'vip',
          Condition: 'OR',
          GroupLv: 1,
          GroupNum: 1,
        },
        {
          Seq: 4,
          Tag: 'firstclass',
          Condition: 'OR',
          GroupLv: 1,
          GroupNum: 1,
        },
      ],
    },
  })

  const editForm = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeCriteria/Edit`,
    method: 'POST',
    payload: {
      Privilege_Id: 1, // required
      Criteria_Group_Id: 2, // required
      Priority: 6, // required
      Name: 'TestChangeNa', // required
      Note: 'TestChangeNote2',
      Req_IdentityId: 1, // required
      Status: 1, // default = 1 = active
    },
  })

  const fetchDetail = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeCriteria/Detail`,
    method: 'POST',
    payload: {
      Privilege_Id: 1, // required
      Criteria_Group_Id: 4, // required
    },
  })

  const deleteItemList = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeCriteria/Delete`,
    method: 'POST',
    payload: {
      Privilege_Id: 1, // required
      Criteria_Group_Id: 3, // required
      Req_IdentityId: 4, // required
    },
  })

  const fetchListData = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeCriteria/List`,
    method: 'POST',
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [{ Seq: 1, Key: 'query', Value: '' }],
      Ordering: [{ Seq: 1, Key: 'priority', Direction: 'desc' }],
      Privilege_Id: 1,
    },
  })

  return {
    createForm,
    editForm,
    fetchDetail,
    deleteItemList,
    fetchListData,
  }
}

export function privilegeExtraPayloadModel() {
  const createForm = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeExtraPayload/Create`,
    method: 'POST',
    payload: {
      Privilege_Id: 1,
      Data_type: 1, // required
      Key: 1, // required
      String_Val: null,
      Int_Val: null,
      Decimal_Val: null,
      Bool_Val: null,
      DateTime_Val: null, // datetime
      Json_Val: null,
    }
  })

  const editForm = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeExtraPayload/Edit`,
    method: 'POST',
    payload: {
      Privilege_Id: 1,
      Payload_Id: 1, // required
      Data_type: 1, // required
      Key: 1, // required
      String_Val: null,
      Int_Val: null,
      Decimal_Val: null,
      Bool_Val: true,
      DateTime_Val: null, // datetime
      Json_Val: null,
    }
  })

  const fetchDetail = reactive({})

  const deleteItemList = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeExtraPayload/Delete`,
    method: 'POST',
    payload: {
      Privilege_Id: 1,
      Payload_Id: 1, // required
    }
  })

  const fetchListData = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeExtraPayload/List`,
    method: 'POST',
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [{ Seq: 1, Key: 'query', Value: '' }],
      Ordering: [{ Seq: 1, Key: 'priority', Direction: 'desc' }],
      Privilege_Id: 1,
    }
  })

  const reorderListData = reactive({
    api: `${apiEndpoint.bcrm_platform}/PrivilegeExtraPayload/Reorder`,
    method: "POST",
    payload: {
      Privilege_Id: null,
      From: null,
      To: null,
      Payload_Id: 1, // required
    },
  });

  return {
    createForm,
    editForm,
    fetchDetail,
    deleteItemList,
    fetchListData,
    reorderListData
  }
}